import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { useContextStore } from './contextStore';

interface SubjectStore {
  activeSubjectId: string | null;
  setActiveSubjectId: (subjectId: string | null) => void;
  clearActiveSubject: () => void;
}

export const useSubjectStore = create<SubjectStore>()(
  persist(
    (set) => ({
      activeSubjectId: null,

      setActiveSubjectId: (subjectId) => {
        set({ activeSubjectId: subjectId });
        // Sync with context store
        const contextStore = useContextStore.getState();
        contextStore.setActiveSubjectId(subjectId);
      },

      clearActiveSubject: () => {
        set({ activeSubjectId: null });
        // Sync with context store
        useContextStore.getState().setActiveSubjectId(null);
      },
    }),
    {
      name: 'subject-storage',
      partialize: (state) => ({ activeSubjectId: state.activeSubjectId }),
    }
  )
);

// Helper to get the active subject ID - now uses context store as source of truth
export const getActiveSubjectId = () => {
  return useContextStore.getState().activeSubjectId;
};
